var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightAngle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 7,
    viewBox: "0 0 5 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99286 3.57624C4.98335 3.60035 4.97685 3.62563 4.96435 3.64896C4.93034 3.71235 4.91083 3.72324 4.85581 3.77535L0.85192 6.88795C0.801403 6.92023 0.749885 6.95289 0.689864 6.97234C0.47779 7.04078 0.210198 6.97817 0.0821535 6.82923C-0.0273845 6.70168 -0.0273845 6.52435 0.0821535 6.39679C0.10016 6.3754 0.123668 6.35752 0.144175 6.33768L3.79394 3.50002L0.144175 0.66275L0.0821535 0.60364C0.0666481 0.581085 0.0486419 0.559696 0.0361375 0.536363C-0.051893 0.371867 0.0261341 0.164983 0.220201 0.0638736C0.384258 -0.0212912 0.612337 -0.0212912 0.776394 0.0638736C0.803404 0.0782622 0.826912 0.0961507 0.85192 0.112484L4.85581 3.22508C4.87632 3.24492 4.89983 3.2628 4.91783 3.28419C4.95434 3.32658 4.97985 3.37402 4.99286 3.42419C5.00536 3.47397 4.99886 3.5253 4.99286 3.57624Z",
    fill: "#212529"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightAngle);
export default __webpack_public_path__ + "static/media/rightAngle.47775d7d38e028bda67993643c04282b.svg";
export { ForwardRef as ReactComponent };